// Fire a download for each URL by injecting a hidden iframe per file.
// The iframe navigates to the presigned URL; S3 returns the object
// with Content-Disposition: attachment, so the browser downloads
// rather than rendering. This path doesn't go through Chrome's
// anchor-click "download multiple files" heuristic at all, so the
// per-file prompt never appears and the back-to-back-clicks
// suppression doesn't kick in either.
//
// Iframes are torn down after a minute — long enough for the
// browser to have started the underlying download, short enough
// that DOM clutter doesn't accumulate if the page stays open.
export function triggerDownloads(urls: string[]): void {
  for (const url of urls) {
    const f = document.createElement("iframe");
    f.style.display = "none";
    f.src = url;
    document.body.appendChild(f);
    setTimeout(() => f.remove(), 60_000);
  }
}
